import Swiper from 'swiper';

class DisplayOptionsProduit {

  constructor(){
    this.clicks    = document.querySelectorAll('[data-trigger="options-produit"]');
    this.component = document.querySelector('[data-component="options-produit-zone"]');
    this.conteneur = document.querySelector('[data-component="conteneur"]');
    this.size = window.innerWidth;
    this._init();
  }

  _init(){
    for (let click of this.clicks) {
      click.addEventListener('click', (event)=> this._clickOnElem(click) );
    }

    if(this.size < 640){
      var innerDiv = document.createElement('a');
      innerDiv.name = 'more-option';
      this.conteneur.appendChild(innerDiv);
    }
  }
  
  _clickOnElem(elem){
    var boolean = elem.classList.contains('active');
    this._hideZone();
    
    if(!boolean){
      elem.classList.add('active');
      this._displayZone(elem.getAttribute('data-options-produit'));
    }
    else {
      this._hideZone();
    }
  }

  _displayZone(id){
    this.component.classList.add('active');
    var attr = this.component.getAttribute('data-options-produit-more');
    this.component.innerHTML = '';
    var o = '';
    attr = JSON.parse(attr);
    attr = attr[id - 1];

    if(attr){
      attr.forEach(element => {
        o += '<div class="single-produit-personnalisation__explicationItem">';
        o += '<div class="single-produit-personnalisation__explicationImg"';
        o += 'style="background-image:url('+element.image+');"></div>';
        o += '<div class="single-produit-personnalisation__explicationTitre">'+element.titre+'</div>';
        o += '</div>';
      });
    }
    else{
      this._hideZone();
    }

    this.component.innerHTML = o;
  }

  
  _hideZone(){
    for (let click of this.clicks) {
      click.classList.remove('active');
    }
    this.component.classList.remove('active');
  }

}

export const displayOptionsProduit = new DisplayOptionsProduit();